import { getBarcodeSize } from "../../constants/barcodes";
import { barcodeToZ64 } from "../../utils/zplBarcode";
import { renderTemplate } from "../BarcodeEditorSideBar/helper";

const labelToCamelCase = (label) => {
  return label
    .split(" ")
    .map((word, index) => {
      const lower = word.toLowerCase();
      if (index === 0) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join("");
};

export const getBarcodeLabels = ({
  data = {},
  fields = [],
  delimiter = "-",
  serialize = false,
  topTemplates = {},
  bottomTemplates = {},
  quantity = 1,
  useBmp = true,
  barcodeFormat,
  size,
}) => {
  const join = delimiter === "Space" ? " " : delimiter;
  const topValues = Object.values(topTemplates);
  const bottomValues = Object.values(bottomTemplates);

  const generatelabel = (index = 0) => {
    const base = fields
      ?.map(({ field = "", format, padding = 0 }) => {
        const key = labelToCamelCase(field);
        const value = key === "index" ? `${index + 1}` : `${data[key]}` || "";

        switch (format) {
          case 2:
            return value?.replace(/\D/g, "").padStart(padding, "0");
          case 3:
            return value?.replace(/\D/g, "");
          default:
            return value;
        }
      })
      ?.join(join);
    const label = base || "Empty";
    return label;
  };

  const getBarcodeOptions = () => {
    const hasTop = topTemplates?.filter(Boolean)?.length > 0;
    const hasBottom = bottomTemplates?.filter(Boolean)?.length > 0;
    const usedSpace = (hasTop ? 14 : 0) + (hasBottom ? 14 : 0) + 24;

    const barcodeHeight = Number(size?.height) * 96 - usedSpace;
    const barcodeWidth = Number(size?.width) * 96 - 12;

    const barcodeOptions = {
      height: barcodeHeight,
      width: barcodeWidth,
      displayValue: true,
    };
    return barcodeOptions;
  };

  if (serialize) {
    const qty = quantity ?? 1;
    return Array.from({ length: qty }, (_, idx) => {
      const index = idx + 1;
      const barcode = generatelabel(idx);
      const top = topValues.map((template) =>
        renderTemplate({ template, data, index, barcode }),
      );
      const bottom = bottomValues.map((template) =>
        renderTemplate({ template, data, index, barcode }),
      );

      const barcodeOptions = useBmp && getBarcodeOptions();
      const barcodeLabel = useBmp
        ? barcodeToZ64(barcode, barcodeFormat, barcodeOptions)
        : barcode;
      return { barcode: barcodeLabel, top, bottom };
    });
  }

  const label = generatelabel();
  const top = topValues.map((template) =>
    renderTemplate({ template, data, barcode: label }),
  );
  const bottom = bottomValues.map((template) =>
    renderTemplate({ template, data, barcode: label }),
  );
  return [{ barcode: label, top, bottom }];
};
